import type { SummitSessionFormat } from "~/lib/summit";

const SESSION_FORMAT_LABELS: Record<SummitSessionFormat, string> = {
  presentation: "Live Presentation",
  workshop: "Live Coaching Workshop",
  panel: "Panel",
  "q&a": "Q&A",
  keynote: "Keynote",
  recording: "Recording",
};

export function formatSummitSessionFormat(
  format?: SummitSessionFormat | null,
): string {
  if (!format) {
    return "Session";
  }

  return SESSION_FORMAT_LABELS[format] ?? "Session";
}
